import React from "react";
import { useNavigate } from "react-router-dom";
import MealExternalPage from "../../components/Tab/MealExternalPage";

const Meals = () => {
  const navigate = useNavigate();

  // const onEditHandle = () => {
  //   navigate("/profile/meals/edit-meal", {
  //     state: { from: "meals" },
  //   });
  // };

  // const handleOnDetails = () => {
  //   navigate("/meal-detail");
  // };

  // const onNextMeal = () => {
  //   navigate("/profile/meals/add-new-meal");
  // };
  return (
    <>
      <div className="w-full">
        <MealExternalPage
          mode="edit" 
          isInternalFlow={false}
        />
      </div>
    </>
  );
};

export default Meals;
